import PropTypes from 'prop-types';
import paymentPropType from './payment';

export default PropTypes.arrayOf(paymentPropType);
